import React, { useEffect, useState } from "react";
import { Card, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import {
  DataTableHead,
  DataTableRow,
  DataTableItem,
  UserAvatar,
  PaginationComponent,
  DataTable,
  Button,
  Icon,
  DataTableBody,
  PreviewAltCard,
} from "../../../Component";
import { recentOrderData } from "./OrderData";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../../../assets/constants";
import MyLoader from "../../../../MyComp/UI/form/MyLoader";
import CancelOrderModal from "../../../../MyComp/UI/modals/CancelOrderModal";
import { UserAvatarCell } from "../../../../MyComp/ImageView/UserAvatarCell";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import AssignOrderModal from "./AssignmentModal";
import { assignBoyAPI, categoryTestDDAPI, getDeliveryBoy } from "../../../../api/dropdown";
import { toast } from "react-toastify";
import { pharmacyDashboardOrdersAPI } from "../../../../api/pahrmacy";
import useLogout from "../../../../hooks/useLogout";
const RecentOrders = ({
  data, 
  isLoading,
  getOrders,
  page,
  paginate,
  currentPage,
  itemPerPage,
  limit,
  setonSearch,
  onSearch,
  setSearchText,
  onSearchText,
  setItemPerPage,
  onOrderClick,
  // toggleCancelOrder,
  noPagination,
  title,
  updateOrderStatus,
  isOpen,
  selectedRow,
  setIsOpen,
  setSelectedRow,
  setValue,
  watch,
  admin
}) => {
   const logout = useLogout();
    const id = localStorage.getItem("userId")
  const [assignModal, setAssignModal] = useState(false);
  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };
  const toggleCancelOrder = () => {};
  const assignOrder = (data) => {
    setAssignModal(true);
    setSelectedRow(data);
  };
  const updateOrder = (data) => {
    setIsOpen(true);
    setSelectedRow(data);
  };
  // const handleClose = () => {
  //   setIsOpen(false);
  // };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleAssignModalClose = () => {
    setAssignModal(false);
    setSelectedRow(null);
  };

  const handleAssignOrder = (order, userId) => {
    const body = {
      // userId: userId,
      pharmacyBoyId: userId,
      orderId: order.id || order.orderNum,
      // assignedDate: new Date().toJSON().slice(0, 10), // 2026-03-11

    };
    const orderBody={
      page:page,
      limit:limit,
      pharmacyId:id||""

    }
    assignBoyAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getOrdersD(orderBody);
          // setAvailableUser(res.data.data.pharmacyBoyList);
          // setValue("categoryDD", res.data.data);
          // setValue("isLoading", false);
        } else if (res.data.status === false) {
          // setValue("isLoading", false);
          // setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          // setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          // logout();
        }
      })
      .catch((err) => {
        // setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
    // Here you would make an API call to assign the order
    console.log("Assigning order:", order, "to user ID:", userId);

    // Find the selected user
    const selectedUser = availableUsers.find((user) => user.id === userId);
    console.log("Selected user:", selectedUser);

    // You can call a prop function to handle the assignment
    // onAssignOrder(order, userId);

    // Show success message or handle accordingly
    // alert(`Order #${order.orderNum} assigned to ${selectedUser?.name}`);
  };
  const [availableUsers, setAvailableUser] = useState([
    // { id: 1, name: "John Doe", email: "john@example.com", role: "Delivery Agent" },
    // { id: 2, name: "Jane Smith", email: "jane@example.com", role: "Delivery Agent" },
    // { id: 3, name: "Mike Johnson", email: "mike@example.com", role: "Delivery Agent" },
    // { id: 4, name: "Sarah Wilson", email: "sarah@example.com", role: "Manager" },
    // { id: 5, name: "Robert Brown", email: "robert@example.com", role: "Delivery Agent" },
  ]);
  useEffect(() => {
    getDeliveryBoyList();
  }, []);
  const getDeliveryBoyList = () => {
    const body = { limit: 10, page: 1 };
    getDeliveryBoy(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setAvailableUser(res.data.data.pharmacyBoyList);
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);

          toast.error(res.data.message);
          toast.clearWaitingQueue();
          // logout();
        }
      })
      .catch((err) => {
        // setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

   const getOrdersD = (body) => {
      pharmacyDashboardOrdersAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.clearWaitingQueue();
            setValue("limit", res.data.data?.totalOrders);
            setValue("page", res.data.data?.page);
            setValue("orderData", res.data.data);
            setValue("tableLoading", false);
          } else if (res.data.status === false) {
            setValue("tableLoading", false);
            setValue("cityDD", []);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("tableLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("tableLoading", false);
          toast.error(err?.response?.data?.message);
        });
    };
const currentData = data || (watch && typeof watch === 'function' ? watch("orderData") : []);
    

  return (
    <>
      <DataTable className={"card-stretch"}>
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h5 className="title">{title}</h5>
            </div>
            <div className="card-tools me-n1">
              <ul className="btn-toolbar gx-1">
                <li>
                  <Button
                    href="#search"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setonSearch(true);
                    }}
                    className="btn-icon search-toggle toggle-search"
                  >
                    <Icon name="search"></Icon>
                  </Button>
                </li>
                <li className="btn-toolbar-sep"></li>
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                      <Icon name="setting"></Icon>
                    </DropdownToggle>
                    <DropdownMenu end className="dropdown-menu-xs">
                      <ul className="link-check">
                        <li>
                          <span>Show</span>
                        </li>
                        {[10, 20, 30, 50, 100].map((num) => (
                          <li key={num}>
                            <DropdownItem
                              className={`dropdown-item ${itemPerPage === num ? "active" : ""}`}
                              href="#dropdownitem"
                              onClick={() => setItemPerPage(num)}
                            >
                              {num}
                            </DropdownItem>
                          </li>
                        ))}
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
            <div className={`card-search search-wrap ${onSearch && "active"}`}>
              <div className="search-content">
                <Button
                  onClick={() => {
                    setSearchText("");
                    setonSearch(false);
                  }}
                  className="search-back btn-icon toggle-search"
                >
                  <Icon name="arrow-left"></Icon>
                </Button>
                <input
                  type="text"
                  className="border-transparent form-focus-none form-control"
                  placeholder="Search..."
                  value={onSearchText}
                  onChange={(e) => onFilterChange(e)}
                />
                <Button className="search-submit btn-icon">
                  <Icon name="search"></Icon>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <DataTableBody bodyclass="nk-tb-tnx">
          <DataTableHead className="nk-tb-item">
            <DataTableRow>
              <span className=" fw-bold">Order No.</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Customer</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Date</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Amount</span>
            </DataTableRow>
            <DataTableRow size={"md"}>
              <span className="fw-bold">Address</span>
            </DataTableRow>
            <DataTableRow size={"md"}>
              <span className="fw-bold">Purchased</span>
            </DataTableRow>
            <DataTableRow size={'md'}>
              <span className="fw-bold">Pharmacy</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Status</span>
            </DataTableRow>
            {/* {toggleCancelOrder && ( */}
           {admin?null: <DataTableRow>
              <span className="fw-bold">Action</span>
            </DataTableRow>}
            {/* )} */}

            {/* <DataTableRow>
              <span className="">Delivery Status</span>
            </DataTableRow> */}
          </DataTableHead>

          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {currentData?.length > 0
                ? currentData?.map((item, idx) => (
                    <DataTableItem key={idx}>
                      {onOrderClick ? (
                        <>
                          <DataTableRow>
                            <span className="tb-lead" onClick={() => onOrderClick(item)}>
                              <a href="#order" onClick={(ev) => ev.preventDefault()}>
                                {item.orderNum}
                              </a>
                            </span>
                          </DataTableRow>
                        </>
                      ) : (
                        <DataTableRow>
                          <span className="tb-lead">
                            <a href="#order" onClick={(ev) => ev.preventDefault()}>
                              {item.orderNum}
                            </a>
                          </span>
                        </DataTableRow>
                      )}

                      <DataTableRow>
                        <div className="user-card">
                          {/* <UserAvatar
                            className="sm"
                            theme={item?.theme}
                            text={item?.initial}
                            image={BASE_URL_IMG + item?.user?.image}
                          ></UserAvatar> */}
                          <UserAvatarCell
                            row={item?.user}
                            name={item?.user?.name}
                            image={`${BASE_URL_IMG + item?.user?.image}`}
                          />
                          <div className="user-name">
                            <span className="tb-lead">{item?.user?.name}</span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub">{item?.date}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub tb-amount">
                          {RUPEES_SYMBOL} {item?.totalAmount}
                        </span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.address}</span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.purchased}</span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.pharmacy_name}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <Badge
                          className="badge-dot badge-dot-xs text-capitalize"
                          color={
                            item?.status === "paid" || item?.status == "delivered"
                              ? "success"
                              : item?.status === "processing" ||
                                  item?.status == "shipped" ||
                                  item?.status == "out_for_delivery"
                                ? "warning"
                                : "danger"
                          }
                        >
                          {item?.status}
                        </Badge>
                      </DataTableRow>
                      {/* {toggleCancelOrder ? ( */}
                     {admin?null: <div className="d-flex flex-wrap justify-content-center align-items-center my-5">
                        {item?.status == "shipped" ? (
                          <Button
                            outline
                            color={`primary`}
                            size={`xs`}
                            className={`me-1`}
                            onClick={() => assignOrder(item)}
                          >
                            {" "}
                            Assign
                          </Button>
                        ) : (
                          <>
                            <>
                             {item?.status != "delivered" && <Button
                                outline
                                color={`primary`}
                                size={`xs`}
                                className={`me-1`}
                                onClick={() => updateOrder(item)}
                              >
                                {" "}
                                Update
                              </Button>}
                            </>
                          </>
                        )}
                        {/* {item?.status == "delivered" || item?.status == "cancelled" ? null : (
                            <>
                              <>
                                <Button
                                  outline
                                  color={`primary`}
                                  size={`xs`}
                                  className={`me-1`}
                                  onClick={() => toggleCancelOrder(item)}
                                >
                                  {" "}
                                  Cancel Order
                                </Button>
                              </>
                            </>
                          )} */}
                        {/* {item?.status == "delivered" || item?.status == "cancelled" ? null : (
                            <>
                              <>
                            {  item?.status == "delivered" &&  <Button
                                  outline
                                  color={`primary`}
                                  size={`xs`}
                                  className={`me-1`}
                                  onClick={() => updateOrder(item)}
                                >
                                  {" "}
                                  Update
                                </Button>}
                              </>
                            </>
                          )}
                           {item?.status == "out_for_delivery"?     <Button
                                  outline
                                  color={`primary`}
                                  size={`xs`}
                                  className={`me-1`}
                                  onClick={() => updateOrder(item)}
                                >
                                  {" "}
                                 Assign 
                                </Button> : (
                            <>
                              <>
                                <Button
                                  outline
                                  color={`primary`}
                                  size={`xs`}
                                  className={`me-1`}
                                  onClick={() => updateOrder(item)}
                                >
                                  {" "}
                                  Update
                                </Button>
                              </>
                            </>
                          )} */}
                      </div>}
                      {/* // ) : ( */}
                      {/* //   <div></div> */}
                      {/* // )} */}
                    </DataTableItem>
                  ))
                : null}
            </>
          )}
        </DataTableBody>
        {noPagination ? null : (
          <PreviewAltCard>
            {currentData?.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={limit}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">{ isLoading ? null : 'No orders found'}</span>
              </div>
            )}
          </PreviewAltCard>
        )}
      </DataTable>

      {/* <Card className="card-full">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h6 className="title">Recent Orders</h6>
            </div>
          </div>
        </div>
        <div className="nk-tb-list mt-n2">
          <DataTableHead>
            <DataTableRow>
              <span>Order No.</span>
            </DataTableRow>
            <DataTableRow size="sm">
              <span>Customer</span>
            </DataTableRow>
            <DataTableRow size="md">
              <span>Date</span>
            </DataTableRow>
            <DataTableRow>
              <span>Amount</span>
            </DataTableRow>
            <DataTableRow>
              <span>Delivery Address</span>
            </DataTableRow>
            <DataTableRow>
              <span className=" ">Status</span>
            </DataTableRow>
            <DataTableRow>
              <span className="">Delivery Status</span>
            </DataTableRow>
          </DataTableHead>
          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {data?.length > 0 ? (
                data.map((item, idx) => (
                  <DataTableItem key={idx}>
                    <DataTableRow>
                      <span className="tb-lead">
                        <a href="#order" onClick={(ev) => ev.preventDefault()}>
                          {item.orderNum}
                        </a>
                      </span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <div className="user-card">
                        <UserAvatar
                          className="sm"
                          theme={item.theme}
                          text={item.initial}
                          image={BASE_URL_IMG + item.user?.image}
                        ></UserAvatar>
                        <div className="user-name">
                          <span className="tb-lead">{item?.user?.name}</span>
                        </div>
                      </div>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="tb-sub">{item.date}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-sub tb-amount">
                        {RUPEES_SYMBOL} {item.totalAmount}
                      </span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="tb-sub">{item.address}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <Badge
                        className="badge-dot badge-dot-xs text-capitalize"
                        color={item.status === "paid" ? "success" : item.status === "due" ? "warning" : "danger"}
                      >
                        {item.status}
                      </Badge>
                    </DataTableRow>
                    <DataTableRow>
                      <Badge
                        className="badge-dot badge-dot-xs text-capitalize"
                        color={item.status === "paid" ? "success" : item.status === "due" ? "warning" : "danger"}
                      >
                        {item.status}
                      </Badge>
                    </DataTableRow>
                  </DataTableItem>
                ))
              ) : (
                <DataTableItem className="text-center">
                  <span>{"No orders found"}</span>
                </DataTableItem>
              )}
              {data?.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={limit}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : null}
            </>
          )}
        </div>
      </Card> */}

      <Modal isOpen={isOpen} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>Order</ModalHeader>

        <ModalBody>
          <p className="mb-0">
            Are you sure you want to update the order status of{" "}
            <strong>Order #{selectedRow?.orderNum || selectedRow?.order_no} </strong> to{" "}
            <strong>
              {selectedRow?.status === "processing" && "Shipped"}
              {selectedRow?.status === "shipped" && "Out for Delivery"}
              {selectedRow?.status === "out_for_delivery" && "Delivered"}
            </strong>{" "}
            placed by <strong>{selectedRow?.user?.name || selectedRow?.address?.full_name}</strong>?
          </p>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            No
          </Button>

          <Button color="danger" onClick={() => updateOrderStatus(selectedRow)}>
            Yes, Update Order
          </Button>
        </ModalFooter>
      </Modal>
      <AssignOrderModal
        isOpen={assignModal}
        toggle={handleAssignModalClose}
        selectedRow={selectedRow}
        users={availableUsers}
        onAssign={handleAssignOrder}
      />
    </>
  );
};
export default RecentOrders;
